<template>
  <div>
    <!-- 核算月 药企 // !查看计算进度start -->
    <el-dialog :title="'查看进度'" :visible.sync="showBox" width="1000px">
      <!-- 搜索区域 -->
      <template v-if="showBox">
        <el-form label-width="100px" class="demo-ruleForm">
          <el-row>
            <el-col :span="12">
              <el-form-item>
                <span slot="label">药企名称 </span>
                <el-select
                  v-model="form.tenantGuid"
                  placeholder="请选择药企名称"
                  filterable
                  class="ipt-sty fl"
                  @change="tenantChange"
                >
                  <el-option
                    v-for="item in companyList"
                    :key="item.sendTenantGuid"
                    :label="item.sendTenantName"
                    :value="item.sendTenantGuid"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item>
                <span slot="label">核算月份</span>
                <el-date-picker
                  class="ipt-sty fl"
                  value-format="yyyy-MM"
                  v-model="form.accountMonth"
                  type="month"
                  placeholder="选择月"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item>
                <span slot="label">组织名称</span>
                <el-select
                  v-model="form.organisationGuid"
                  filterable
                  placeholder="请选择"
                  class="ipt-sty fl"
                  @focus="getOrganisation()"
                >
                  <el-option
                    v-for="item in organisationList"
                    :key="item.guid"
                    :label="item.organisationName"
                    :value="item.guid"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-button size="mini" type="info" @click="getList()">搜索</el-button>
              <el-button size="mini" type="danger" @click="empty">清空</el-button>
            </el-col>
          </el-row>
        </el-form>
      </template>

      <!-- 表格区域 -->
      <template>
        <div class="back-color-fff content-main-box" style="height:300px">
          <el-table :data="tableData" style="width: 100%" border stripe :height="300">
            <el-table-column label="序号" width="60" header-align="center" align="center">
              <template slot-scope="scope">
                {{ (form.pageIndex - 1) * form.pageSize + scope.$index + 1 }}
              </template>
            </el-table-column>
            <el-table-column prop="createTime" label="公司名称" width="160" header-align="center" align="left">
              <template slot-scope="scope">{{ scope.row.tenantName || '-' }}</template>
            </el-table-column>
            <el-table-column prop="createTime" label="组织名称" width="120" header-align="center" align="left">
              <template slot-scope="scope">{{ scope.row.organisationName || '-' }}</template>
            </el-table-column>
            <el-table-column prop="createTime" label="核算月" width="120" header-align="center" align="left">
              <template slot-scope="scope">{{ scope.row.accountMonth || '-' }}</template>
            </el-table-column>
            <el-table-column prop="createTime" label="计算进度" width="96" header-align="center" align="left">
              <template slot-scope="scope">{{ scope.row.state | progressStatus }}</template>
            </el-table-column>
            <el-table-column prop="createTime" label="计算完成时间" width="140" header-align="center" align="left">
              <template slot-scope="scope">{{ scope.row.endTime | getTimeDate }}</template>
            </el-table-column>
            <el-table-column prop="result" label="耗时(秒)" width="80" header-align="center" align="left">
              <template slot-scope="scope">{{ scope.row.useSecond }}</template>
            </el-table-column>
            <el-table-column prop="createTime" label="提交人" width="120" header-align="center" align="left">
              <template slot-scope="scope">{{ scope.row.createUserName || '-' }}</template>
            </el-table-column>
            <el-table-column prop="createTime" label="提交时间" width="140" header-align="center" align="left">
              <template slot-scope="scope">{{ scope.row.createTime | getTimeDate }}</template>
            </el-table-column>
            <el-table-column prop="result" label="计算结果" width="110" header-align="center" align="left" show-overflow-tooltip >
              <template slot-scope="scope">{{ scope.row.result || '-' }}</template>
            </el-table-column>
          </el-table>
        </div>
        <el-pagination
          class="pt pb back-color-fff"
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 50, 100, 200]"
          :current-page="form.pageIndex"
          :page-size="form.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="form.totalRows"
        >
        </el-pagination>
      </template>
    </el-dialog>
    <!-- // !查看计算进度 end -->
  </div>
</template>

<script>
export default {
  props: {
    showProgressBox: {
      type: Boolean,
      default: false,
    },
    companyList: {
      type: Array,
      default: [],
    },
  },
  filters: {
    progressStatus(val) {
      if (val == '' || val == null) {
        return '-';
      } else {
        if (val === 'F') {
          return '执行完成';
        } else if (val === 'P') {
          return '执行中';
        }
  }
    }
  },
  data() {
    return {
      tableData:[],
      showBox: false,
      form: {
        taskType:'2',
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,
        tenantGuid: '',
        accountMonth: '',
        organisationGuid: '',
      },
      organisationList: [],
    };
  },
  watch: {
    showBox(val) {
      if (val) {
        this.getList()
      }
      this.$emit('update:showProgressBox', val);
    },
    showProgressBox(val) {
      console.log(val);
      this.showBox = val;
    },
  },
  methods: {
    handleSizeChange(val) {
      this.form.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.form.pageIndex = val;
      this.getList();
    },
    getOrganisation(type) {
      if (!this.form.tenantGuid && type !== 1) {
        this.$message.error('请选择药企名称后再选择部门!');
        return;
      }
    },
    // 选择企业change
    tenantChange(val) {
      if (val) {
        this.getOrganisationList(val);
      }
    },
    //获取组织
    getOrganisationList(v) {
      let self = this;
      let query = {
        pageIndex: 1,
        pageSize: -1,
        tenantGuid: v,
        sendTenantGuid: localStorage.guid,
      };
      self.api.postJson(`/${serverConfig.msPersonnelService}/organisation/data/get`, query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.organisationList = res.data.data.records || [];
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    getList() {
      let { form } = this
      let query = JSON.parse(JSON.stringify(form))
      if (query.accountMonth) {
        query.accountMonth = query.accountMonth.replace('-', '');
      }
      this.api.postJson(`/${serverConfig.msSalesPerformService}/kafka-job/data/get-list`, query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.tableData = res.data.data.records || [];
          this.form.totalPage = res.data.data.totalPages;
          this.form.totalRows = res.data.data.totalRows;
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    empty() {
      this.form = {
        taskType:'2',
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,
        tenantGuid: '',
        accountMonth: '',
        organisationGuid: '',
      }
      this.getList()
    }
  },
};
</script>

<style lang="less" scoped>
</style>
